import { useCallback } from 'react';
import { message } from 'antd';
import { useUploadAsset } from './use-upload-asset';
import { useEditorContext } from '../context/editor-context';

/** Group ID fijo — un solo avatar group para todo */
const AVATAR_GROUP_ID = 'a1dbcef6f7cb45e78e3b87fa0e09f151';

const delay = (ms: number) => new Promise(r => setTimeout(r, ms));

/**
 * Centralizes the upload-then-update-state pattern used by VestuarioSection.
 * Supports batch uploads (multiple files) processed sequentially.
 */
export const useAssetUploadHandler = () => {
  const { onAvatarUploaded } = useEditorContext();
  const { uploadAsset, isUploading, setIsUploading, uploadProgress, setUploadProgress } = useUploadAsset();

  const handleAvatarUpload = useCallback(
    async (files: File[]) => {
      setIsUploading(true);
      let succeeded = 0;
      let failed = 0;

      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const name = file.name.replace(/\.[^.]+$/, '');
          setUploadProgress(`${i + 1}/${files.length}`);

          const res = await uploadAsset({
            file,
            avatarGroupId: AVATAR_GROUP_ID,
            avatarName: name
          });

          if (res) {
            const avatarId = res.avatarId || res.assetId;
            console.table({ avatarId, label: name });
            onAvatarUploaded({ id: avatarId, label: name, imageUrl: res.url, groupId: AVATAR_GROUP_ID });
            succeeded++;
          } else {
            failed++;
          }

          // Delay entre uploads para evitar rate limiting de HeyGen / timeout de API Gateway
          if (i < files.length - 1) {
            await delay(3000);
          }
        }
      } finally {
        setIsUploading(false);
        setUploadProgress('');
      }

      if (failed === 0) {
        message.success(`${succeeded} vestuario${succeeded > 1 ? 's' : ''} subido${succeeded > 1 ? 's' : ''}`);
      } else {
        message.warning(`${succeeded} subidos, ${failed} con error`);
      }
    },
    [uploadAsset, onAvatarUploaded, setIsUploading, setUploadProgress]
  );

  return { handleAvatarUpload, isUploading, uploadProgress };
};
